import { render, staticRenderFns } from "./TermoUso.vue?vue&type=template&id=251f40e6"
import script from "./TermoUso.vue?vue&type=script&lang=js"
export * from "./TermoUso.vue?vue&type=script&lang=js"
import style0 from "./TermoUso.vue?vue&type=style&index=0&id=251f40e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports